import { DateTime } from 'luxon';

const getTodaysDateFormatted = (): string => {
  return DateTime.now().toUTC().startOf('day').toISODate();
};

export const getPlannerShiftDefaultFilter = (): string => {
  return `?fromDate=${getTodaysDateFormatted()}`;
};

export const getAvailabilityDefaultFilter = (): string => {
  return `?fromDate=${getTodaysDateFormatted()}`;
};

export const getPlannerProjectDefaultFilter = (): string => {
  return `?toDate=${getTodaysDateFormatted()}`;
};

export const getPlannerPlacementDefaultFilter = (): string => {
  return `?fromDate=${getTodaysDateFormatted()}`;
};

export const getFinancePaymentsDefaultFilter = (): string => {
  return `?creationDate=${getTodaysDateFormatted()}`;
};
